import React, { Component } from 'react';
import { connect } from 'react-redux';
import { GetNewDashboardStats } from '../dashboard/actions';
import TopHeader from './components/TopHeader';
import DashboardHeader from './components/DashboardHeader';
import StatsCards from './components/StatsCards';
import DashboardChartsWrapper from './components/DashboardChartsWrapper';
import DashboardBottomWrapper from './components/DashboardBottomWrapper';
import './style.css';

class NewAdminDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      statsData: null,
      filters: { months: 12 }
    };
  }

  componentDidMount() {
    this.loadStats();
  }

  updateFilters = (newFilters) => {
    this.setState(
      (prevState) => ({ filters: { ...prevState.filters, ...newFilters } }),
      () => {
        this.loadStats();
      }
    );
  };

  loadStats = async () => {
    let { success, data } = await this.props.dispatch(GetNewDashboardStats(this.state.filters));
    if (success) {
      this.setState({ statsData: data });
    }
  };

  render() {
    let { statsData } = this.state;

    return (
      <div>
        <div className="adminDashboardWrapper">

          <DashboardHeader
            onGlobalFilterChange={(globalFilters) => this.updateFilters(globalFilters)}
          />

          <StatsCards data={statsData} />

          <DashboardChartsWrapper
            data={statsData}
            onMonthFilterChange={(months) => this.updateFilters({ months })}
          />

          <DashboardBottomWrapper data={statsData} />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({ dispatch });
export default connect(null, mapDispatchToProps)(NewAdminDashboard);